import { TaskTypeEnum } from "api/api.typing";
import { TaskFileUploadType } from "pages/project/common/taskBase.typing";
import {
  useDeliveryFileMappingOptions,
  usePreprocessingDeliveryInfo,
  usePreprocessingInputData,
  useTask,
} from "query/task.query";

/**
 * Hook that manages preprocessing file mapping data fetching and conditions
 * Determines when to show the file mapping section and fetches required data
 */
export const usePreprocessingFileMapping = (taskId: string, fileType: TaskFileUploadType, newFileNames: string[]) => {
  const { selectedTask, isLoading: isTaskLoading } = useTask(taskId);
  const isAuxiliaryTask = selectedTask?.taskTypeEnum === TaskTypeEnum.Auxiliary;

  const { preprocessingInfo, willTriggerCatUpdates } = usePreprocessingDeliveryInfo(
    taskId,
    isAuxiliaryTask && fileType === "delivery"
  );

  // Determine if file mapping section should be shown
  const shouldShowSection =
    !isTaskLoading &&
    !!(willTriggerCatUpdates && preprocessingInfo && fileType === "delivery" && preprocessingInfo.updateMode);

  const { sourceFiles, targetLanguages } = usePreprocessingInputData(taskId, shouldShowSection);

  const { fileMappingSuggestions } = useDeliveryFileMappingOptions(
    taskId,
    newFileNames,
    shouldShowSection && newFileNames.length > 0
  );

  return {
    shouldShowSection,
    sourceFiles,
    targetLanguages,
    fileMappingSuggestions,
  };
};
